import { createPortal } from 'react-dom';
import {

  ModalContent,
  ModalOverlay,
  CloseBtn,
  ScrollBox,
} from './Modal.styled';
import ImageAnimation3 from 'components/layout/loader/ImageAnimation3';

const modalRoot = document.querySelector('#root-module');

const Modal = ({ children, onClose, pad, heightT = false, loading = 1,nqe = false }) => {
  // console.log('loading :>> ', loading);
  const handleContentClick = event => {
    event.stopPropagation();
  };
console.log('nqe :>> ', nqe);
  return createPortal(
    <ModalOverlay onClick={onClose} nqe={nqe?"true":"false"} >
  {    loading===0? <ImageAnimation3/>:
      <ModalContent onClick={handleContentClick} heightT={heightT ? 'true' : 'false'} >
          <ScrollBox pad={pad} nqe={nqe?"true":"false"} >
          {pad !== "false"  && <CloseBtn onClick={onClose} />}

            {children}
          </ScrollBox>
      </ModalContent>}
    </ModalOverlay>,
    modalRoot
  );
};

export default Modal;
